import axios from 'axios';

export const Api = axios.create({
  baseURL: process.env.REACT_APP_API_BACKEND
});

export const API_URL = process.env.REACT_APP_API_BACKEND;
